export default __webpack_public_path__ + "static/luisspainting-78ceb79cec1a5bd931902095f512e2e2.png";